<script lang="ts">
  import * as _ from "lodash";
  import { onMount } from "svelte";
  import { params, redirect } from "@roxi/routify";
  import { getPreviouslyOrderedList } from "@shared/services/list_service";
  import retailerContext from "@modern/services/retailer_context";
  import { HttpPromise, HttpPromiseWithEntireResponse } from "@shared/svelte/Modules/ApiService";
  import OrderGroupsIndexPage from "@retailer/svelte/OrderGroups/Page.svelte";
  import DistributorsStore from "@shared/svelte/Stores/DistributorsStore";
  import { stagedRolloutCheck } from "@shared/svelte/Modules/StagedRolloutCheck.svelte";

  let data;
  interface StateParams {
    page: number;
    search: string;
    distributors: number[];
    orderStates: string[];
    fromDate: string;
    toDate: string;
  }
  let stateParams: StateParams = {
    page: 1,
    search: "",
    distributors: [],
    orderStates: [],
    fromDate: null,
    toDate: null,
  };

  const orderGroupsRes = async () => {
    if (
      parseInt($params.setRetailerID) &&
      parseInt($params.setRetailerID) !== retailerContext.get().id
    ) {
      retailerContext.setAndGo(parseInt($params.setRetailerID));
    }
    if (stateParams.distributors && !_.isArray(stateParams.distributors)) {
      stateParams.distributors = [stateParams.distributors];
    }
    if (stateParams.orderStates && !_.isArray(stateParams.orderStates)) {
      stateParams.orderStates = [stateParams.orderStates];
    }

    var ogParams = {
      limit: 10,
      offset: 10 * ((stateParams.page || 1) - 1),
      search: stateParams.search,
      distributor_id: stateParams.distributors,
      order_state: stateParams.orderStates,
      from_date: stateParams.fromDate,
      to_date: stateParams.toDate,
    };
    $redirect(
      "/orders",
      _.omitBy(stateParams, v => v === null || v === undefined || v === "")
    );

    try {
      let res = await HttpPromiseWithEntireResponse({
        method: "GET",
        url: "/api/retailer/order_groups",
        data: ogParams,
      });
      let ordersRes;
      if (res.ok) {
        ordersRes = { data: await res.json() };
        ordersRes.headers = function (h) {
          return res.headers.get(h);
        };
      }
      return ordersRes;
    } catch (e) {
      return { data: [], headers: () => {} };
    }
  };

  const distributorsRes = async () => {
    let res = [];
    res = await HttpPromise({
      method: "GET",
      url: "/api/retailer/distributors",
      data: {
        with_integrated: true,
        with_sales_reps: true,
        with_domains: true,
      },
    }).catch(() => (res = []));
    DistributorsStore.set(res);
    return res;
  };

  const recentlyOrderedListsRes = async () => {
    const hasPreviouslyOrderedAutogeneratedListsRollout = stagedRolloutCheck(
      "marketplace__previously_ordered_autogenerated_lists"
    );

    if (
      !hasPreviouslyOrderedAutogeneratedListsRollout &&
      window.sessionStorage.getItem("hide-reorder-panel")
    ) {
      return [];
    }

    let res = [];
    res = await HttpPromise({
      method: "GET",
      url: "/api/retailer/quick_order_lists",
      data: { search: "Recently Ordered" },
    }).catch(() => (res = []));
    return res;
  };

  const load = async () => {
    const hasPreviouslyOrderedRollout = stagedRolloutCheck(
      "marketplace__previously_ordered_autogenerated_lists"
    );

    const [distributors, orderGroups, recentlyOrderedLists, previouslyOrderedList] =
      await Promise.all([
        distributorsRes(),
        orderGroupsRes(),
        recentlyOrderedListsRes(),
        hasPreviouslyOrderedRollout ? getPreviouslyOrderedList() : Promise.resolve(null),
      ]);

    return {
      distributors: distributors.sort((a, b) =>
        a.name.toLowerCase().localeCompare(b.name.toLowerCase())
      ),
      orderGroups,
      recentlyOrderedLists,
      previouslyOrderedList,
    };
  };

  let enableUpdates = false;
  onMount(async () => {
    stateParams = _.clone($params) as StateParams;
    data = await load();
    enableUpdates = true;
  });

  const refreshState = async changes => {
    if (!changes.page) {
      changes.page = null;
    }
    const newParams = _.clone(stateParams);
    _.extend(newParams, changes);
    stateParams = newParams as StateParams;
    data.orderGroups = await orderGroupsRes();
  };

</script>

{#if data}
  {#key data.orderGroups}
    <OrderGroupsIndexPage
      distributors={data.distributors}
      orderGroupsRes={data.orderGroups}
      recentlyOrderedListsRes={data.recentlyOrderedLists}
      previouslyOrderedList={data.previouslyOrderedList}
      {stateParams}
      {refreshState}
    />
  {/key}
{/if}
